import React, { useState, useEffect, useRef } from "react";
import { Space, Input, Select, Button, Dropdown, Menu } from "antd";
import { DatePicker } from "../../../components/antOverrides";
import {
  PlusOutlined,
  DownOutlined,
  DownloadOutlined,
  UploadOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import { useParams, useLocation } from "react-router-dom";
import { useIntl } from "react-intl";
import { SearchOutlined } from "@ant-design/icons";
import {
  generateEmployeesFile,
  generateProfessionalEmployeesFile,
  generateMeserFile,
} from "../../../api/server";
import { exportProspectuses, generateMasavReport } from "../prospectusesSlice";
import moment from "moment";
import { openURL } from "../../../components/util/helpers";
import UploadBtlFile from "./UploadBtlFile";
import { useUserBranches } from "../../../hooks/accessControl";
import { useDispatch, useSelector } from "react-redux";
import { usePermission } from "../../../hooks/accessControl";
import BtlErrorsTable from "./BtlErrorsTable";
import ExportProspectusesModal from "./ExportProspectusesModal";
import GenerateMasavReportModal from "./GenerateMasavReport";
import UploadMeserFile from "./UploadMeserFile";
import ExportMeserModal from "./ExportMeserModal";
import GenerateMasavReportTable from "./GenerateMasavReportTable"; // Import the new component
const { Option } = Select;

const Header = (props) => {
  const {
    onDateChange,
    onTextChange,
    onBranchChange,
    activeDate,
    activeBranch,
    textFilter,
    onShowNewPaymentRequests,
    prospectuses,
    onShowUploadFile,
  } = props;
  const intl = useIntl();
  const userBranches = useUserBranches();
  const dispatch = useDispatch();
  let { branchId } = useParams();
  let location = useLocation();
  const inputRef = useRef();
  const profile = useSelector((state) => state.user.profile);
  const [uploadVisible, setUploadVisible] = useState(false);
  const [exportPropspectusesVisible, setExportPropspectusesVisible] =
    useState(false);
  const [branchName, setBranchName] = useState("");
  const [btlUploadErrors, setBtlUploadErrors] = useState([]);
  const [generateMasavReportItems, setGenerateMasavReportItems] = useState([]);
  const [uploadMeserFileVisible, setUploadMeserFileVisible] = useState(false);
  const [exportMeserVisible, setExportMeserVisible] = useState(false);
  const [meserLoading, setMeserLoading] = useState(false);
  const [generateMasavReportVisible, setGenerateMasavReportVisible] =
    useState(false);

  const isAdmin = location.pathname.includes("admin");
  const branch_id = branchId ? branchId : activeBranch;
  const exportLoading = useSelector(
    (state) => state.pendingActions["prospectus/export"]
  );
  const generateMasavLoading = useSelector(
    (state) => state.pendingActions["prospectuses/generateMasavReport"]
  );
  const accountingExportType = useSelector(
    (state) => state.organization.details.accounting_export_type
  );
  const isMerhav = accountingExportType === "מרחב";
  const accountingExportEnabled = true; //accountingExport && accountingExport.active;

  useEffect(() => {
    const branch = userBranches.filter((i) => i.id === +branchId)[0];
    if (branch) {
      setBranchName(branch.name);
    }
    if (inputRef && inputRef.current) {
      const { input } = inputRef.current;
      input.focus();
    }
  }, [userBranches, branchId]);
  const onDownloadProfessionalFile = async () => {
    const params = {
      period: {
        year: +moment(activeDate).format("YYYY"),
        month: +moment(activeDate).format("M"),
      },
      branchId: branch_id,
    };
    const action = await generateProfessionalEmployeesFile(params);
    openURL(action.file_url);
  };

  const onDownloadEmployeesFile = async () => {
    const params = {
      period: {
        year: +moment(activeDate).format("YYYY"),
        month: +moment(activeDate).format("M"),
      },
      branchId: branch_id,
    };
    const action = await generateEmployeesFile(params);
    openURL(action.file_url);
  };
  const onDownloadBtlFile = async () => {
    onShowUploadFile("btl");
  };

  const handleMeserFile = async (values) => {
    const params = {
      branch_id: +branch_id,
      incremental: values.incremental,
    };
    if (!values.incremental) {
      params["year"] = values.month
        ? values.year
        : +moment(activeDate).format("YYYY");
      params["month"] = values.month
        ? values.month
        : +moment(activeDate).format("M");
    }

    try {
      setMeserLoading(true);
      const action = await generateMeserFile(params);
      setExportMeserVisible(false);
      openURL(action.file_url);
    } finally {
      setMeserLoading(false);
    }
  };

  const showMeserModal = () => {
    setExportMeserVisible(true);
  };

  const handleImportMeserFile = () => {
    setUploadMeserFileVisible(true);
  };

  const onDownloadKerenFile = async () => {
    onShowUploadFile("keren");
  };

  const handleUploadBtlFile = () => {
    setUploadVisible(true);
  };

  const hideUpload = () => {
    setUploadVisible(false);
  };

  const handleExportPropspectuses = () => {
    setExportPropspectusesVisible(true);
  };

  const hideExportPropspectuses = () => {
    setExportPropspectusesVisible(false);
  };

  const handleGenerateMasavReport = () => {
    setGenerateMasavReportVisible(true);
  };

  const hideGenerateMasavReport = () => {
    setGenerateMasavReportVisible(false);
  };

  const hideGenerateMasavReportTable = () => {
    setGenerateMasavReportItems([]);
  };

  const onGenerateMasavReport = async (values) => {
    const params = { ...values };
    Object.keys(params).forEach((key) => {
      if (params[key] === undefined) {
        delete params[key];
      }
    });

    const data = {
      branchId: branchId || values.branchId,
      params: params,
    };

    const action = await dispatch(generateMasavReport(data));
    if (!action.error) {
      hideGenerateMasavReport();
      if (action.payload?.data?.file_url) {
        openURL(action.payload.data.file_url);
      }
      const repsonseItems = action.payload?.data?.report?.Rows || [];
      setGenerateMasavReportItems(repsonseItems); // Set the items here
    }
  };

  const onExport = async (values) => {
    const data = {
      branchId,
      params: {
        year: +moment(values.month).format("YYYY"),
        month: +moment(values.month).format("M"),
        branch_ids: values.all_branches ? null : values.branches,
        incremental: values.incremental,
        single_file: values.single_file,
        annual_sequence_numbers: values.annual_sequence_numbers,
      },
    };

    const action = await dispatch(exportProspectuses(data));
    if (!action.error) {
      hideExportPropspectuses();
      openURL(action.payload.data.file_url);
    }
  };

  const handleMenuClick = (e, record) => {
    switch (e.key) {
      case "1":
        onShowNewPaymentRequests();
        break;
      case "2":
        onDownloadEmployeesFile();

        break;
      case "3":
        onDownloadProfessionalFile();
        break;
      case "4":
        onDownloadBtlFile();
        break;
      case "5":
        onDownloadKerenFile();
        break;
      case "6":
        handleUploadBtlFile();
        break;
      case "7":
        showMeserModal();
        break;
      case "8":
        handleExportPropspectuses();
        break;
      case "9":
        handleImportMeserFile();
        break;
      case "10":
        handleGenerateMasavReport();
        break;
      default:
        break;
    }
  };

  const hasEditorPermission = usePermission(branchId, "accounting", "editor");

  let items = [];

  items.push({
    label: intl.formatMessage({
      id: "app.prospectuses.newPaymentRequest",
    }),
    key: "1",
    icon: <PlusOutlined />,
    disabled: !hasEditorPermission,
  });

  if (branch_id && activeDate) {
    items.push({
      label: intl.formatMessage({
        id: "app.prospectuses.download_employees_file",
      }),
      key: "2",
      icon: <DownloadOutlined />,
    });
  }

  if (branch_id && activeDate) {
    items.push({
      label: intl.formatMessage({
        id: "app.prospectuses.download_professional_file",
      }),
      key: "3",
      icon: <DownloadOutlined />,
    });
  }

  if (branch_id && prospectuses && prospectuses.length > 0) {
    items.push({
      label: intl.formatMessage({
        id: "app.prospectuses.download_btl_file",
      }),
      key: "4",
      icon: <DownloadOutlined />,
    });
  }

  if (branch_id && prospectuses && prospectuses.length > 0) {
    items.push({
      label: intl.formatMessage({
        id: "app.prospectuses.download_keren_file",
      }),
      key: "5",
      icon: <DownloadOutlined />,
    });
  }

  if (branch_id && activeDate) {
    items.push({
      label: intl.formatMessage({
        id: "app.prospectuses.upload_btl_file",
      }),
      key: "6",
      icon: <UploadOutlined />,
    });
  }
  if (branch_id && activeDate) {
    items.push({
      label: intl.formatMessage({
        id: "app.prospectuses.download_meser_file",
      }),
      key: "7",
      icon: <DownloadOutlined />,
    });
  }
  if (branch_id) {
    items.push({
      label: intl.formatMessage({
        id: "app.prospectuses.upload_meser_file",
      }),
      key: "9",
      icon: <UploadOutlined />,
    });
  }

  const hasExportPermission = usePermission(branchId, "accounting", "exporter");

  if (accountingExportEnabled && hasExportPermission) {
    items.push({
      label: intl.formatMessage({
        id: "app.prospectuses.export_prospectuses",
      }),
      key: "8",
      icon: <ExportOutlined />,
    });
  }
  items.push({
    label: intl.formatMessage({
      id: "app.prospectuses.generate_masav_report",
    }),
    key: "10",
    icon: <ExportOutlined />,
  });

  const menu = { items, onClick: (e) => handleMenuClick(e) };

  const hideExportMeser = () => {
    setExportMeserVisible(false);
  };

  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <Space direction="horizontal">
        <DatePicker
          value={activeDate}
          onChange={onDateChange}
          picker="month"
          format={"MM/YYYY"}
          placeholder={intl.formatMessage({
            id: `app.gaps.select_month`,
          })}
        />
        {isAdmin ? (
          <Select
            style={{ width: "200px" }}
            defaultValue={branchId ? parseInt(branchId) : undefined}
            showSearch
            placeholder={intl.formatMessage({
              id: "app.users.chooseBranch",
            })}
            optionFilterProp="children"
            onChange={onBranchChange}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            value={activeBranch}
            allowClear
          >
            {profile.branches
              ? profile.branches.map((b) => (
                  <Option value={b.id} key={b.id}>
                    {b.name}
                  </Option>
                ))
              : null}
          </Select>
        ) : null}
        <Input
          prefix={
            <SearchOutlined style={{ padding: "0  5px", opacity: 0.4 }} />
          }
          placeholder={intl.formatMessage({
            id: `app.prospectuses.typeInvoiceNumber`,
          })}
          value={textFilter}
          onChange={(e) => onTextChange(e.target.value)}
          style={{ width: 300 }}
          allowClear
          ref={inputRef}
        />
      </Space>

      <Dropdown trigger={["click"]} placement="bottomLeft" menu={menu}>
        <Button type="link">
          {intl.formatMessage({
            id: "app.salary.options",
          })}
          <DownOutlined />
        </Button>
      </Dropdown>
      <UploadBtlFile
        visible={uploadVisible}
        hide={hideUpload}
        branch_id={branch_id}
        setBtlUploadErrors={setBtlUploadErrors}
      />
      <ExportProspectusesModal
        onHide={hideExportPropspectuses}
        visible={exportPropspectusesVisible}
        title={
          !branchId
            ? intl.formatMessage({
                id: "app.prospectuses.export_prospectuses",
              })
            : `${intl.formatMessage({
                id: "app.prospectuses.export_prospectuses_for_branch",
              })}${branchName}`
        }
        btnText={intl.formatMessage({
          id: "app.actions.export",
        })}
        initialValues={{
          month: activeDate,
          branches: branch_id ? [+branch_id] : [],
          incremental: isMerhav ? true : false,
          all_branches: isMerhav ? true : false,
          single_file: true,
          year: moment(),
        }}
        onSubmit={onExport}
        branchId={branchId}
        loading={exportLoading}
        isMerhav={isMerhav}
      />

      <GenerateMasavReportModal
        onHide={hideGenerateMasavReport}
        visible={generateMasavReportVisible}
        title={intl.formatMessage({
          id: "app.prospectuses.generate_masav_report",
        })}
        btnText={intl.formatMessage({
          id: "app.actions.generate",
        })}
        initialValues={{
          month: activeDate,
          // branches: branch_id || null,
          incremental: false,
          dry_run: true,
          year: moment(),
          // single_file: true,
        }}
        onSubmit={onGenerateMasavReport}
        branchId={branchId}
        loading={generateMasavLoading}
        single={true}
      />
      <BtlErrorsTable
        visible={btlUploadErrors.length > 0}
        btlUploadErrors={btlUploadErrors}
        onHide={() => setBtlUploadErrors([])}
      />
      <GenerateMasavReportTable
        visible={generateMasavReportItems.length > 0}
        items={generateMasavReportItems}
        onHide={hideGenerateMasavReportTable}
      />
      <UploadMeserFile
        visible={uploadMeserFileVisible}
        hide={() => setUploadMeserFileVisible(false)}
        branch_id={branch_id}
      />
      <ExportMeserModal
        visible={exportMeserVisible}
        onHide={hideExportMeser}
        onSubmit={handleMeserFile}
        title={intl.formatMessage({
          id: "app.prospectuses.download_meser_file",
        })}
        btnText={intl.formatMessage({
          id: "app.actions.export",
        })}
        initialValues={{
          incremental: true,
          month: activeDate,
        }}
        loading={meserLoading}
      />
    </div>
  );
};

export default Header;
